import { __values } from "tslib";
export var urlMappingsArrayToObject = function (urlMappingsEntities) {
    var e_1, _a;
    if (!Array.isArray(urlMappingsEntities)) {
        return;
    }
    var urlMappings = { main: [] };
    try {
        for (var urlMappingsEntities_1 = __values(urlMappingsEntities), urlMappingsEntities_1_1 = urlMappingsEntities_1.next(); !urlMappingsEntities_1_1.done; urlMappingsEntities_1_1 = urlMappingsEntities_1.next()) {
            var urlMappingEntity = urlMappingsEntities_1_1.value;
            var languageKey = urlMappingEntity.languageKey, urlMappingsForLanguageKey = urlMappingEntity.urlMappings;
            if (languageKey) {
                urlMappings[languageKey] = urlMappingsForLanguageKey;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (urlMappingsEntities_1_1 && !urlMappingsEntities_1_1.done && (_a = urlMappingsEntities_1.return)) _a.call(urlMappingsEntities_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return urlMappings;
};
//# sourceMappingURL=url-mappings-array-to-object.js.map